'use client';

import { QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { createQueryClient } from '~/lib/query-client';

export const QueryClientProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // Create a new QueryClient instance for each client component
  // This prevents sharing query state between different users and requests
  const [queryClient] = useState(() => createQueryClient());

  return (
    <ReactQueryClientProvider client={queryClient}>
      {children}
    </ReactQueryClientProvider>
  );
};
